// src/store/themeSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentTheme: "light", // Default theme
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleTheme: (state) => {
      if (state.currentTheme === "light") {
        state.currentTheme = "dark";
      } else {
        state.currentTheme = "light";
      }
    },
  },
});

export const { toggleTheme } = themeSlice.actions;

export default themeSlice.reducer;
